import { ConfermaPage } from './../conferma/conferma';
import { Component, Injector, AfterViewInit, ViewChild } from '@angular/core';
import { NavController, LoadingController, Events, MenuController, Content } from 'ionic-angular';
import { Util } from '../../app/util';
import { DettaglioPage } from '../dettaglio/dettaglio';
import { CreditsPage } from '../credits/credits';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage extends Util implements AfterViewInit {

  @ViewChild(Content) content: Content
  prodotti: any = {};
  allProdotti: any = {};
  allProdottiCategoria: any = {};
  keyprod: any = [];
  category = 'c1';
  today: string = "";
  user: any = null;
  searchText: string = "";
  currCategoria: any = null;
  placeholderCerca: string = "Cerca...";
  isHtml: string = null;

  constructor(public navCtrl: NavController, injector: Injector, loadingCrtl: LoadingController, public events: Events, public menuCtrl: MenuController) {
    super(injector, loadingCrtl)
    events.subscribe('cambiocategoria', (categoria) => {
      this.isHtml = null;
      this.currCategoria = categoria;


      if (this.currCategoria == null || this.currCategoria.id == 0) {
        this.placeholderCerca = "Cerca..."
        this.prodotti = JSON.parse(JSON.stringify(this.allProdotti)); //me ne serve una copia this.allProdotti;

      } else {

        if (this.allProdotti != {} && this.allProdotti[this.category]['blocchi'] != undefined) {
          this.placeholderCerca = "Cerca in " + this.currCategoria.nome + "...";
          this.prodotti[this.category]['blocchi'] = this.allProdotti[this.category]['blocchi'].filter((item) => {
            return (item.categoria_app.toLowerCase().indexOf(this.currCategoria.nome.toLowerCase()) > -1);
          })
        }
      }

      this.allProdottiCategoria = JSON.parse(JSON.stringify(this.prodotti));

    });
    events.subscribe('caricaHtml', (html) => {

      var content = "";
      var titolo = "Info";

      if (html == 'chisiamo') {
        content = "<h3>INOLTRA IL TUO ORDINE CON Enoteca Pistilli Comfort Zone !</h3><br><br>Un servizio offerto dall’Enoteca Pistilli capace di portare direttamente a casa tua vino, bollicine, liquori, distillati, acqua e bibite varie con un semplice messaggio whatsApp (331.6291300)<br><ul><li>Attiva il servizio WhatsApp scrivendo il tuo Nome e Cognome</li><li>Ricevi il volantino</li><li>Ordini con pochissimi click</li><li>Scegli luogo, data e orario di consegna</li><li>Il gioco è fatto!</li></ul><br>Servizio disponibile per  Campobasso e  Ferrazzano";
        titolo = "Chi Siamo";

      } else if (html == 'costi') {
        content = "<h3>Costi</h3><b>Campobasso Centro città</b><br>Da 1 a 2 bottiglie € 3,50<br>Da 3 a 6 bottiglie € 5,00<br>Da 1 a 5 cartoni/casse € 5,00<br>Da 5 a 10 cartoni/casse € 10,00<br><br><b>Campobasso Contrade + Ferrazzano</b><br>Da 1 a 2 bottiglie € 5,00 <br>Da 3 a 6 bottiglie € 6,50<br>Da 1 a 5 cartoni/casse € 6,50<br>Da 5 a 10 cartoni/casse € 11,50<br>";
        titolo = "Costi di consegna";
      } else if (html == 'raccolta') {
        content = "<h3>Raccolta punti ENOTECA PISTILLI</h3><b>PREMI 2019</b><br><br>1° PREMIO 4 punti: 2 bt di Birra<br>2° PREMIO 8 punti: 1 bt di Vodka<br>3° PREMIO 12 punti: 1 bt di Grappa <br>4° PREMIO 16 punti:  1 Bt di Amarone<br>5° PREMIO 20 punti: 6 Coppe Champagne<br><br>1 PUNTO OGNI € 20,00 DI SPESA<br><br><br><i>* Tutti i premi sono esposti presso l‘Enoteca Pistilli<br>Via IV Novembre, 89 (CB)<br>* Il ritiro del premio azzera i bollini accumulati<br>* I premi sono soggetti a cambiamento in base alla disponibilità degli stessi<br>* La raccolta punti ha validità 1 anno: 01.01.2019 - 31.12.2019<br></i>";
        titolo = "Raccolta punti"
      }
      this.openModal(CreditsPage, { content: content, titolo: titolo });


    });

  }
  openMenu() {
    this.menuCtrl.open();
  }

  closeMenu() {
    this.menuCtrl.close();
  }

  toggleMenu() {
    this.menuCtrl.toggle();
  }

  
  
  ngOnInit(): void {

    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    if (this.plt.is('mobileweb') && this.plt.is('ios')) {
      this.content.enableJsScroll()
    }

    var that = this;
    this.storage.get('userparams').then(user => {
      that.user = user;
    });

    this.postrequest();
    //console.log(this.user);
    
  }

  

  postrequest() {

    var urlParameters = this.getUrlParameters();

    var that = this;
    this.GetRequest(Util.getUrlServer() + 'action=getJSON&who=delivery&apri='+urlParameters['apri'], '', true, true).then((res) => {
    //this.GetRequest(Util.getUrlServer() + 'action=getJSON&who=delivery', '', true, true).then((res) => {
      //var r = JSON.parse('' + res + '');
      that.prodotti = res['prodotti'];
      that.allProdotti = JSON.parse(JSON.stringify(this.prodotti)); //me ne serve una copia
      that.allProdottiCategoria = JSON.parse(JSON.stringify(this.prodotti)); //me ne serve una copia
      that.today = res['today'];
      that.events.publish('categorieCaricate', res['categorie']);
      that.keyprod = Object.keys(that.allProdotti);

      // for (let i = 0; i < that.keyprod.length; i++) {
      //   var c = that.allProdotti[that.keyprod[i]]['blocchi'];
      //   for (let y = 0; y < c.length; y++) {
      //     c[y].q = 0;
      //     c[y].r = 0;
      //   }
      // }
    }).catch((err) => {
      that.showBasicAlert('Errore', 'Errore prodotti');
    })

  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    // setTimeout(() => {
    //   this.set_category(this.keyprod[0]);
    // }, 3000);

  }


  segmentChanged(e) {
    //console.log(this.category);
    //console.log(this.prodotti[this.category]['blocchi']);
    //console.log(e);
  }

  calcolaPrezzo(prodotto) {

    var prezzo_finale = 0;
    if (prodotto.q == 0) {
      prezzo_finale = prodotto.prezzo;
    } else {
      prezzo_finale = prodotto.prezzo * prodotto.q;
    }

    prezzo_finale = (Math.round(prezzo_finale * 100) / 100);
    var x = prezzo_finale.toFixed(2);
    var prezzoStr = x.toString();
    prezzoStr = prezzoStr.replace(".", ',');

    return "Prezzo: " + prezzoStr + " € + Spese di consegna";
  }




  ionChange() {
    //console.log("ionChange fired");
    //console.log(this.searchText);
    //console.log(this.keyprod);
    //console.log(this.category);
    //console.log(this.prodotti[this.category]['blocchi']);

    if (this.searchText == "") {
      this.prodotti = JSON.parse(JSON.stringify(this.allProdottiCategoria)); //me ne serve una copia this.allProdotti;
    } else {

      this.prodotti[this.category]['blocchi'] = this.allProdottiCategoria[this.category]['blocchi'].filter((item) => {
        //console.log(item);
        return ((item.nome.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1) || (item.keywords_app.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1));
      })

      //console.log(this.allProdotti[this.category]['blocchi'].length);

    }



  }
  ionInput() {
    //console.log("ionInput fired");
  }

  updateq(prodotto, t, k) {

    //console.log(prodotto);
    //console.log(prodotto);
    //this.prodotti[k]['blocchi'][i]

    if (t == 'm') {
      prodotto.q--;
      this.calcolaPrezzo(prodotto);
    }
    else if (t == 'p') {
      prodotto.q++;
      this.calcolaPrezzo(prodotto);
    }
    else if (t == 'mr') {
      prodotto.r--;
    }
    else if (t == 'pr') {
      prodotto.r++;
    }

    for (let i = 0; i < this.allProdotti[k]['blocchi'].length; i++) {
      let p = this.allProdotti[k]['blocchi'][i];
      if (p.id == prodotto.id) {
        p.q = prodotto.q;
        p.r = prodotto.r;
      }
    }
  }


  getUrlParameters() {

    var urlParameters = {};
    if (document.URL.indexOf("?") > 0) {
      let splitURL = document.URL.split("?");
      let splitParams = splitURL[1].split("&");
      let i: any;
      for (i in splitParams){
        let singleURLParam = splitParams[i].split('=');

        /*
        if (singleURLParam[0] == "category"){
          this.category = singleURLParam[1];
        }
        if (singleURLParam[0] == "id"){
          this.id = singleURLParam[1];
        }*/

        urlParameters[singleURLParam[0]] = singleURLParam[1];

        
      
      }
    }

    return urlParameters;

    /*
    var id_to_open = urlParameters['apri'];
    if(id_to_open != null && this.allProdotti['c1'] != null) {

      //id_prod_wp == 6894
      var c = this.allProdotti['c1']['blocchi'];

      for (let y = 0; y < c.length; y++) {
        if (c[y].id_prod_wp == id_to_open) {
          var prod = c[y];
          prod.q = 1;
          this.confermaConProdotto(prod);
          break;
        }
      }
      

      
    }*/
    
  }

  confermaConProdotto(prodotto: any) {

    var carrello_acquisto: any = [];
    var carrello_reso: any = [];

    if (prodotto != null) {

      carrello_acquisto.push(prodotto);

    } else {

        var keyprod = Object.keys(this.allProdotti);
    

        for (let i = 0; i < keyprod.length; i++) {
          var c = this.allProdotti[keyprod[i]]['blocchi'];
          for (let y = 0; y < c.length; y++) {
            if (c[y].q > 0) {
              carrello_acquisto.push(c[y]);
            }

            if (c[y].hasReso && (c[y].q > 0 || c[y].r > 0)) {
              carrello_reso.push(c[y]);
            }


          }
        }
        

        

    }

    if (carrello_acquisto.length < 1) {
      this.showBasicAlert('Attenzione', 'Per proseguire devi scegliere almeno un prodotto');
    } else {

      this.navCtrl.push(ConfermaPage, {
        carrello_acquisto: carrello_acquisto,
        carrello_reso: carrello_reso,
        today: this.today
      });
    }

  }

  conferma() {

    //console.log(this.prodotti);

    this.confermaConProdotto(null);


  }
  set_category(k) {
    for (let i = 0; i < this.keyprod.length; i++) {
      var z = document.getElementById(this.keyprod[i]);
      if (z != null) {
        z.classList.remove('segment-activated');
      }
    }
    var x = document.getElementById(k);
    if (x != null) {
      x.classList.add('segment-activated');
    }
    this.category = k;
  }
  open_detail(item) {
    this.openModal(DettaglioPage, { prodotto: item });
    //console.log(item);
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts